import { Button, Form } from "react-bootstrap";
import { Image } from "react-bootstrap";
import logo from "../../assets/hlg logo.webp";

const AuthForm = ({ title, subtitle, fields, onSubmit, buttonText, isButtonDisabled, googleBtn }) => {
  return (
    <div
      className="d-flex min-vh-100"
      style={{ backgroundColor: "var(--bg-base)" }}
    >
      <div
        className="d-none d-md-flex w-50 flex-column justify-content-center align-items-center text-white p-5 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-elevated) 100%)",
        }}
      >
        {/* Decorative accent glows - purely visual, no data */}
        <div
          style={{
            position: "absolute",
            top: "-120px",
            left: "-80px",
            width: 320,
            height: 320,
            borderRadius: "50%",
            background: "var(--accent)",
            opacity: 0.18,
            filter: "blur(70px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-140px",
            right: "-100px",
            width: 380,
            height: 380,
            borderRadius: "50%",
            background: "var(--accent-2)",
            opacity: 0.14,
            filter: "blur(90px)",
          }}
        />

        <Image src={logo} alt="HLG logo" height={64} className="mb-4 position-relative" style={{ objectFit: "contain" }} />
        <h1 className="text-center position-relative" style={{ fontWeight: 600 }}>
          Welcome to the QC Bot
        </h1>
        <p className="text-center mt-2 position-relative" style={{ color: "var(--text-secondary)", maxWidth: 380 }}>
          Automated call quality control, disposition tracking, and compliance
          monitoring, all in one place.
        </p>
      </div>

      <div
        className="w-100 w-md-50 d-flex flex-column justify-content-center align-items-center p-4"
        style={{ backgroundColor: "var(--bg-surface)" }}
      >
        <div
          className="w-100 p-4 p-md-5"
          style={{
            maxWidth: 420,
            backgroundColor: "var(--bg-elevated)",
            borderRadius: "var(--radius)",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow-card)",
          }}
        >
          <Image
            src={logo}
            alt="HLG logo"
            height={40}
            className="d-md-none mb-3"
            style={{ objectFit: "contain" }}
          />
          <h3 className="mb-1" style={{ color: "var(--text-primary)", fontWeight: 600 }}>
            {title}
          </h3>
          {subtitle && (
            <p className="mb-4" style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
              {subtitle}
            </p>
          )}
          <Form onSubmit={onSubmit} noValidate className={subtitle ? "" : "mt-4"}>
            {fields}
            <Button
              type="submit"
              className="w-100 mt-2"
              disabled={isButtonDisabled}
              style={{
                backgroundColor: "var(--accent)",
                border: "none",
                padding: "10px",
                fontWeight: 600,
                borderRadius: "var(--radius-sm)",
              }}
            >
              {isButtonDisabled && (
                <span className="spinner-border spinner-border-sm me-2" role="status" />
              )}
              {buttonText}
            </Button>
            {googleBtn}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
